// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuAccordion-sideMenuAccordionHeader-P105U {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
}

.SideMenuAccordion-sideMenuAccordionHeaderBtn-YTRfs {
    padding: 12px 16px;
    border-radius: var(--radius-1);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    margin-bottom: 4px;
    gap: 8px;
    color: var(--sideMenu-primary-foreground);
    text-decoration: none;
    background: transparent;
    border: none;
    outline: none;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    text-align: start;
}

.SideMenuAccordion-sideMenuAccordionHeaderBtn-YTRfs:hover,
.SideMenuAccordion-sideMenuAccordionHeaderBtn-YTRfs:focus,
.SideMenuAccordion-sideMenuAccordionHeaderBtn-YTRfs:active,
.SideMenuAccordion-sideMenuAccordionHeaderBtn-YTRfs:active:hover,
.SideMenuAccordion-sideMenuAccordionHeaderBtn-YTRfs:active:focus,
.SideMenuAccordion-sideMenuAccordionHeaderActiveBtn-zm50e,
.SideMenuAccordion-sideMenuAccordionHeaderActiveBtn-zm50e:hover,
.SideMenuAccordion-sideMenuAccordionHeaderActiveBtn-zm50e:focus {
    background: var(--sideMenu-hover);
    color: var(--sideMenu-primary-foreground);
    text-decoration: none;
    outline: unset;
    -webkit-box-shadow: unset;
            box-shadow: unset;
}

.SideMenuAccordion-sideMenuAccordionItemIconContainer-K8Ufs,
.SideMenuAccordion-sideMenuAccordionItemArrow-vF8h7,
.SideMenuAccordion-sideMenuAccordionCollapseItemIcon-wqgC8 {
    -ms-flex-negative: 0;
        flex-shrink: 0;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}

.SideMenuAccordion-sideMenuAccordionItemIconContainer-K8Ufs {
    top: 1px;
    width: 20px;
    height: 20px;
}

.SideMenuAccordion-sideMenuAccordionItemArrow-vF8h7 {
    top: 4px;
    width: 15px;
    height: 15px;
}

.SideMenuAccordion-sideMenuAccordionCollapseItemIcon-wqgC8 {
    top: 3px;
    width: 16px;
    height: 16px;
}

.SideMenuAccordion-sideMenuAccordionItemIconContainer-K8Ufs svg,
.SideMenuAccordion-sideMenuAccordionItemArrow-vF8h7 svg,
.SideMenuAccordion-sideMenuAccordionCollapseItemIcon-wqgC8 svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
}

.SideMenuAccordion-sideMenuAccordionItemTextContainer-WE2BT,
.SideMenuAccordion-sideMenuAccordionCollapseItemText-PgRzN {
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    white-space: pre-line;
    word-break: break-word;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
}

.SideMenuAccordion-sideMenuAccordionItemArrow-vF8h7 svg {
    -webkit-transform: rotate(0);
        -ms-transform: rotate(0);
            transform: rotate(0);
    -webkit-transition-property: -webkit-transform;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform;
    -webkit-transition-timing-function: cubic-bezier(.4, 0, .2, 1);
            transition-timing-function: cubic-bezier(.4, 0, .2, 1);
    -webkit-transition-duration: .2s;
            transition-duration: .2s;
}

.SideMenuAccordion-sideMenuAccordionItemActiveArrow-uINzz svg {
    -webkit-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
            transform: rotate(180deg);
    -webkit-transition-property: -webkit-transform;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform;
    -webkit-transition-timing-function: cubic-bezier(.4, 0, .2, 1);
            transition-timing-function: cubic-bezier(.4, 0, .2, 1);
    -webkit-transition-duration: .2s;
            transition-duration: .2s;
}

.SideMenuAccordion-sideMenuAccordionCollapseItem-dQ0yK {
    padding: 8px 24px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 8px;
    border-radius: var(--radius-1);
    color: var(--sideMenu-primary-foreground);
    margin-bottom: 4px;
    text-decoration: none;
    text-align: start;
}

.SideMenuAccordion-sideMenuAccordionCollapseItem-dQ0yK:hover,
.SideMenuAccordion-sideMenuAccordionCollapseItem-dQ0yK:focus,
.SideMenuAccordion-sideMenuAccordionCollapseItemActive-hfOf3,
.SideMenuAccordion-sideMenuAccordionCollapseItemActive-hfOf3:hover,
.SideMenuAccordion-sideMenuAccordionCollapseItemActive-hfOf3:focus {
    background: var(--sideMenu-hover);
    color: var(--sideMenu-primary-foreground);
    text-decoration: none;
    outline: unset;
    -webkit-box-shadow: unset;
            box-shadow: unset;
}`, "",{"version":3,"sources":["webpack://./src/components/SideMenu/SideMenuAccordion.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,yCAAyC;IACzC,qBAAqB;IACrB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;;;;;;;IAQI,iCAAiC;IACjC,yCAAyC;IACzC,qBAAqB;IACrB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;;;IAGI,oBAAc;QAAd,cAAc;IACd,kBAAkB;IAClB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,4BAAoB;QAApB,wBAAoB;YAApB,oBAAoB;IACpB,8CAA8B;IAA9B,sCAA8B;IAA9B,8BAA8B;IAA9B,iDAA8B;IAC9B,8DAAsD;YAAtD,sDAAsD;IACtD,gCAAwB;YAAxB,wBAAwB;AAC5B;;AAEA;IACI,iCAAyB;QAAzB,6BAAyB;YAAzB,yBAAyB;IACzB,8CAA8B;IAA9B,sCAA8B;IAA9B,8BAA8B;IAA9B,iDAA8B;IAC9B,8DAAsD;YAAtD,sDAAsD;IACtD,gCAAwB;YAAxB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,QAAQ;IACR,8BAA8B;IAC9B,yCAAyC;IACzC,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;;;;IAKI,iCAAiC;IACjC,yCAAyC;IACzC,qBAAqB;IACrB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;AACrB","sourcesContent":[".sideMenuAccordionHeader {\n    display: flex;\n    flex-direction: column;\n}\n\n.sideMenuAccordionHeaderBtn {\n    padding: 12px 16px;\n    border-radius: var(--radius-1);\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 4px;\n    gap: 8px;\n    color: var(--sideMenu-primary-foreground);\n    text-decoration: none;\n    background: transparent;\n    border: none;\n    outline: none;\n    flex-grow: 1;\n    text-align: start;\n}\n\n.sideMenuAccordionHeaderBtn:hover,\n.sideMenuAccordionHeaderBtn:focus,\n.sideMenuAccordionHeaderBtn:active,\n.sideMenuAccordionHeaderBtn:active:hover,\n.sideMenuAccordionHeaderBtn:active:focus,\n.sideMenuAccordionHeaderActiveBtn,\n.sideMenuAccordionHeaderActiveBtn:hover,\n.sideMenuAccordionHeaderActiveBtn:focus {\n    background: var(--sideMenu-hover);\n    color: var(--sideMenu-primary-foreground);\n    text-decoration: none;\n    outline: unset;\n    box-shadow: unset;\n}\n\n.sideMenuAccordionItemIconContainer,\n.sideMenuAccordionItemArrow,\n.sideMenuAccordionCollapseItemIcon {\n    flex-shrink: 0;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.sideMenuAccordionItemIconContainer {\n    top: 1px;\n    width: 20px;\n    height: 20px;\n}\n\n.sideMenuAccordionItemArrow {\n    top: 4px;\n    width: 15px;\n    height: 15px;\n}\n\n.sideMenuAccordionCollapseItemIcon {\n    top: 3px;\n    width: 16px;\n    height: 16px;\n}\n\n.sideMenuAccordionItemIconContainer svg,\n.sideMenuAccordionItemArrow svg,\n.sideMenuAccordionCollapseItemIcon svg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    object-position: center;\n}\n\n.sideMenuAccordionItemTextContainer,\n.sideMenuAccordionCollapseItemText {\n    flex-grow: 1;\n    white-space: pre-line;\n    word-break: break-word;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n}\n\n.sideMenuAccordionItemArrow svg {\n    transform: rotate(0);\n    transition-property: transform;\n    transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n    transition-duration: .2s;\n}\n\n.sideMenuAccordionItemActiveArrow svg {\n    transform: rotate(180deg);\n    transition-property: transform;\n    transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n    transition-duration: .2s;\n}\n\n.sideMenuAccordionCollapseItem {\n    padding: 8px 24px;\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    border-radius: var(--radius-1);\n    color: var(--sideMenu-primary-foreground);\n    margin-bottom: 4px;\n    text-decoration: none;\n    text-align: start;\n}\n\n.sideMenuAccordionCollapseItem:hover,\n.sideMenuAccordionCollapseItem:focus,\n.sideMenuAccordionCollapseItemActive,\n.sideMenuAccordionCollapseItemActive:hover,\n.sideMenuAccordionCollapseItemActive:focus {\n    background: var(--sideMenu-hover);\n    color: var(--sideMenu-primary-foreground);\n    text-decoration: none;\n    outline: unset;\n    box-shadow: unset;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideMenuAccordionHeader": `SideMenuAccordion-sideMenuAccordionHeader-P105U`,
	"sideMenuAccordionHeaderBtn": `SideMenuAccordion-sideMenuAccordionHeaderBtn-YTRfs`,
	"sideMenuAccordionHeaderActiveBtn": `SideMenuAccordion-sideMenuAccordionHeaderActiveBtn-zm50e`,
	"sideMenuAccordionItemIconContainer": `SideMenuAccordion-sideMenuAccordionItemIconContainer-K8Ufs`,
	"sideMenuAccordionItemArrow": `SideMenuAccordion-sideMenuAccordionItemArrow-vF8h7`,
	"sideMenuAccordionCollapseItemIcon": `SideMenuAccordion-sideMenuAccordionCollapseItemIcon-wqgC8`,
	"sideMenuAccordionItemTextContainer": `SideMenuAccordion-sideMenuAccordionItemTextContainer-WE2BT`,
	"sideMenuAccordionCollapseItemText": `SideMenuAccordion-sideMenuAccordionCollapseItemText-PgRzN`,
	"sideMenuAccordionItemActiveArrow": `SideMenuAccordion-sideMenuAccordionItemActiveArrow-uINzz`,
	"sideMenuAccordionCollapseItem": `SideMenuAccordion-sideMenuAccordionCollapseItem-dQ0yK`,
	"sideMenuAccordionCollapseItemActive": `SideMenuAccordion-sideMenuAccordionCollapseItemActive-hfOf3`
};
module.exports = ___CSS_LOADER_EXPORT___;
